import template from './settings.html';
import controller from './settings.controller';
import './settings.scss';

let settingsComponent = {
  restrict: 'E',
  bindings: {
    acl: '='
  },
  template,
  controller
};

export default settingsComponent;


// WEBPACK FOOTER //
// ./client/app/components/settings/settings.component.js